import { type QueryCache, type QueryKey } from "@tanstack/vue-query";
import { type Entity, isCollection } from "~/src/api";

export function getSingleEntityFromCache(
  cache: QueryCache,
  entityType: string,
  entityId: string,
) {
  const singleMatch = cache.find({
    queryKey: [entityType, "entity", entityId],
    exact: false,
  });
  if (singleMatch?.state.data) {
    return singleMatch.state.data;
  }

  const cacheMatches = cache.findAll({
    queryKey: [entityType, "entity_list"],
    exact: false,
  });
  for (const match of cacheMatches) {
    if (isCollection(match.state.data)) {
      const found = match.state.data.data.find(
        (en) => (en as Entity<string, any>).id === entityId,
      );
      if (found) return found;
    }
  }

  return undefined;
}

type UnwrapFn<T> = T extends () => infer R ? R : T;

type NormalizeArgs<T extends QueryKey> = {
  [K in keyof T]: UnwrapFn<T[K]>;
};

export function extractQueryKey<Q extends QueryKey>(
  quueryKey: Q,
): NormalizeArgs<Q> {
  return quueryKey.map((q) =>
    typeof q === "function" ? q() : q,
  ) as NormalizeArgs<Q>;
}
